export default {
  copyrights: {
    en: 'SCENTBIRD © {year}, All rights reserved.',
  },
  madeWith: {
    en: 'Made with <span></span> in NYC.',
  },
}
